// styles/base/components/buttons.js
/**
 * Button component overrides and variants
 * Because interactive elements should respond with both purpose and panache
 */

import { colors } from '../tokens';

export const buttonOverrides = {
    MuiButton: {
        defaultProps: {
            disableElevation: true, // Flat design principles - elevation should be earned, not assumed
        },
        variants: [
            // Bootstrap-aligned button styling - familiar yet refined
            {
                props: { variant: 'bootstrap' },
                style: {
                    textTransform: 'none',
                    borderRadius: '4px',
                    fontSize: '0.875rem',
                    padding: '6px 12px',
                },
            },
            {
                props: { variant: 'bootstrap', size: 'small' },
                style: {
                    padding: '4px 8px',
                    fontSize: '0.75rem',
                },
            },

            // Semantic colour variants - because context matters
            {
                props: { variant: 'info' },
                style: {
                    backgroundColor: colors.info,
                    color: '#ffffff',
                    '&:hover': {
                        filter: 'brightness(0.9)',
                    },
                },
            },
            {
                props: { variant: 'dark' },
                style: {
                    backgroundColor: colors.text,
                    color: colors.ground,
                    '&:hover': {
                        filter: 'brightness(0.85)',
                    },
                },
            },
            {
                props: { variant: 'light' },
                style: {
                    backgroundColor: colors.panelFill,
                    color: colors.text,
                    '&:hover': {
                        filter: 'brightness(0.95)',
                    },
                },
            },
        ],
    },
};
